import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
export default class CharacterSheetPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.sheetData = null;
    this.status = null;
    this.isOwner = false;
    this.isPublic = true;
    this.updatedAt = null;
    this.loadingSheet = true;
    this.togglingVisibility = false;
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    this.loadCharacterSheet();
  }
  loadCharacterSheet() {
    if (!this.user) return;
    this.loadingSheet = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/users/".concat(this.user.id(), "/character-sheet")
    }).then(response => {
      this.status = response.status;
      this.sheetData = response.sheet;
      this.isOwner = !!response.is_owner;
      this.isPublic = response.is_public !== undefined ? !!response.is_public : true;
      this.updatedAt = response.updated_at;
      this.loadingSheet = false;
      m.redraw();
    }).catch(err => {
      this.loadingSheet = false;
      this.status = 'error';
      console.error(err);
      m.redraw();
    });
  }
  toggleVisibility() {
    if (!this.user || this.togglingVisibility) return;
    this.togglingVisibility = true;
    const newPublicState = !this.isPublic;
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/users/".concat(this.user.id(), "/character-sheet/visibility"),
      body: {
        is_public: newPublicState
      }
    }).then(response => {
      this.isPublic = !!response.is_public;
      this.togglingVisibility = false;
      app.alerts.show({
        type: 'success'
      }, this.isPublic ? app.translator.trans('nagusi-character-sheet.forum.settings.privacy_label') : app.translator.trans('nagusi-character-sheet.forum.private_by_owner.title'));
      m.redraw();
    }).catch(err => {
      this.togglingVisibility = false;
      console.error(err);
      m.redraw();
    });
  }
  content() {
    if (this.loading || this.loadingSheet) {
      return m("div", {
        className: "CharacterSheet-loading"
      }, m(LoadingIndicator, null));
    }

    // 1. Pending / Not processed yet
    if (this.status === 'pending') {
      return m("div", {
        className: "CharacterSheet-stateBox CharacterSheet-stateBox--pending"
      }, m("div", {
        className: "CharacterSheet-stateIcon"
      }, m("i", {
        className: "fas fa-clipboard-list"
      })), m("h3", {
        className: "CharacterSheet-stateTitle"
      }, app.translator.trans('nagusi-character-sheet.forum.empty.title')), m("p", {
        className: "CharacterSheet-stateDesc"
      }, app.translator.trans('nagusi-character-sheet.forum.empty.description')));
    }

    // 2. Hidden by viewer (Reciprocity violation: viewer has their own sheet hidden)
    if (this.status === 'hidden_by_viewer') {
      return m("div", {
        className: "CharacterSheet-stateBox CharacterSheet-stateBox--locked"
      }, m("div", {
        className: "CharacterSheet-stateIcon"
      }, m("i", {
        className: "fas fa-user-lock"
      })), m("h3", {
        className: "CharacterSheet-stateTitle"
      }, app.translator.trans('nagusi-character-sheet.forum.hidden_by_viewer.title')), m("p", {
        className: "CharacterSheet-stateDesc"
      }, app.translator.trans('nagusi-character-sheet.forum.hidden_by_viewer.description')), m("div", {
        className: "CharacterSheet-stateAction"
      }, m(Link, {
        className: "Button Button--primary",
        href: app.route('settings')
      }, m("i", {
        className: "fas fa-cog"
      }), " ", app.translator.trans('core.forum.settings.title'))));
    }

    // 3. Private by target user
    if (this.status === 'private') {
      return m("div", {
        className: "CharacterSheet-stateBox CharacterSheet-stateBox--private"
      }, m("div", {
        className: "CharacterSheet-stateIcon"
      }, m("i", {
        className: "fas fa-user-shield"
      })), m("h3", {
        className: "CharacterSheet-stateTitle"
      }, app.translator.trans('nagusi-character-sheet.forum.private_by_owner.title')), m("p", {
        className: "CharacterSheet-stateDesc"
      }, app.translator.trans('nagusi-character-sheet.forum.private_by_owner.description')));
    }

    // 4. Login required
    if (this.status === 'login_required') {
      return m("div", {
        className: "CharacterSheet-stateBox CharacterSheet-stateBox--login"
      }, m("div", {
        className: "CharacterSheet-stateIcon"
      }, m("i", {
        className: "fas fa-sign-in-alt"
      })), m("h3", {
        className: "CharacterSheet-stateTitle"
      }, app.translator.trans('nagusi-character-sheet.forum.login_required.title')), m("p", {
        className: "CharacterSheet-stateDesc"
      }, app.translator.trans('nagusi-character-sheet.forum.login_required.description')), m("div", {
        className: "CharacterSheet-stateAction"
      }, m(Button, {
        className: "Button Button--primary",
        onclick: () => app.modal.show(LogInModal)
      }, m("i", {
        className: "fas fa-sign-in-alt"
      }), " ", app.translator.trans('core.forum.header.log_in_link'))));
    }
    if (!this.sheetData) {
      return null;
    }
    const locale = app.translator.getLocale();
    const data = this.sheetData[locale] || this.sheetData['es'] || Object.values(this.sheetData)[0] || {};
    const dateUpdated = this.sheetData.updated_at || this.updatedAt;
    return m("div", {
      className: "CharacterSheet-container"
    }, m("div", {
      className: "CharacterSheet-hero"
    }, m("div", {
      className: "CharacterSheet-heroMeta"
    }, dateUpdated && m("span", {
      className: "CharacterSheet-badge DateBadge"
    }, m("i", {
      className: "fas fa-history"
    }), " ", app.translator.trans('nagusi-character-sheet.forum.last_updated', {
      date: dateUpdated
    })), this.isOwner && m(Button, {
      className: "Button Button--text CharacterSheet-visibilityBtn ".concat(this.isPublic ? 'is-public' : 'is-private'),
      loading: this.togglingVisibility,
      onclick: () => this.toggleVisibility(),
      title: app.translator.trans('nagusi-character-sheet.forum.settings.privacy_help')
    }, m("i", {
      className: "fas ".concat(this.isPublic ? 'fa-eye' : 'fa-eye-slash')
    }), ' ', this.isPublic ? 'Visible para todos' : 'Privada (Solo tú)')), m("div", {
      className: "CharacterSheet-heroHeader"
    }, m("div", {
      className: "CharacterSheet-classBox"
    }, m("span", {
      className: "CharacterSheet-roleLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.class_label')), m("h2", {
      className: "CharacterSheet-className"
    }, m("i", {
      className: "fas fa-shield-alt"
    }), " ", data.class || 'Forero')), data.alignment && m("div", {
      className: "CharacterSheet-alignmentBox"
    }, m("span", {
      className: "CharacterSheet-roleLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.alignment_label')), m("div", {
      className: "CharacterSheet-alignmentValue"
    }, m("i", {
      className: "fas fa-balance-scale"
    }), " ", data.alignment)))), data.attributes && data.attributes.length > 0 && m("div", {
      className: "CharacterSheet-section CharacterSheet-attributesSection"
    }, m("h3", {
      className: "CharacterSheet-sectionTitle"
    }, m("i", {
      className: "fas fa-chart-pie"
    }), " ", app.translator.trans('nagusi-character-sheet.forum.attributes_title')), m("div", {
      className: "CharacterSheet-attributesList"
    }, data.attributes.map(attr => {
      const max = attr.max || 20;
      const value = Math.min(Math.max(attr.value || 0, 0), max);
      const percent = Math.round(value / max * 100);
      return m("div", {
        className: "CharacterSheet-attributeItem",
        key: attr.key || attr.label
      }, m("div", {
        className: "CharacterSheet-attrHeader"
      }, m("span", {
        className: "CharacterSheet-attrLabel"
      }, attr.label), m("span", {
        className: "CharacterSheet-attrScore"
      }, m("strong", null, value), " / ", max)), m("div", {
        className: "CharacterSheet-progressTrack"
      }, m("div", {
        className: "CharacterSheet-progressBar",
        style: {
          width: "".concat(percent, "%")
        }
      })), attr.desc && m("p", {
        className: "CharacterSheet-attrDesc"
      }, attr.desc));
    }))), data.inventory && m("div", {
      className: "CharacterSheet-section CharacterSheet-inventorySection"
    }, m("h3", {
      className: "CharacterSheet-sectionTitle"
    }, m("i", {
      className: "fas fa-box-open"
    }), " ", app.translator.trans('nagusi-character-sheet.forum.inventory_title')), m("div", {
      className: "CharacterSheet-inventoryGrid"
    }, data.inventory.weapon && m("div", {
      className: "CharacterSheet-invCard"
    }, m("div", {
      className: "CharacterSheet-invIcon"
    }, m("i", {
      className: "fas fa-crosshairs"
    })), m("div", {
      className: "CharacterSheet-invContent"
    }, m("span", {
      className: "CharacterSheet-invLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.inventory.weapon')), m("span", {
      className: "CharacterSheet-invValue"
    }, data.inventory.weapon))), data.inventory.fetish_players && m("div", {
      className: "CharacterSheet-invCard"
    }, m("div", {
      className: "CharacterSheet-invIcon"
    }, m("i", {
      className: "fas fa-star"
    })), m("div", {
      className: "CharacterSheet-invContent"
    }, m("span", {
      className: "CharacterSheet-invLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.inventory.fetish_players')), m("span", {
      className: "CharacterSheet-invValue"
    }, data.inventory.fetish_players))), data.inventory.nemesis && m("div", {
      className: "CharacterSheet-invCard"
    }, m("div", {
      className: "CharacterSheet-invIcon"
    }, m("i", {
      className: "fas fa-skull-crossbones"
    })), m("div", {
      className: "CharacterSheet-invContent"
    }, m("span", {
      className: "CharacterSheet-invLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.inventory.nemesis')), m("span", {
      className: "CharacterSheet-invValue"
    }, data.inventory.nemesis))), data.inventory.passive_skill && m("div", {
      className: "CharacterSheet-invCard"
    }, m("div", {
      className: "CharacterSheet-invIcon"
    }, m("i", {
      className: "fas fa-magic"
    })), m("div", {
      className: "CharacterSheet-invContent"
    }, m("span", {
      className: "CharacterSheet-invLabel"
    }, app.translator.trans('nagusi-character-sheet.forum.inventory.passive_skill')), m("span", {
      className: "CharacterSheet-invValue"
    }, data.inventory.passive_skill))))), data.mister_report && data.mister_report.comment && m("div", {
      className: "CharacterSheet-section CharacterSheet-misterSection"
    }, m("div", {
      className: "CharacterSheet-misterCard"
    }, m("div", {
      className: "CharacterSheet-misterHeader"
    }, m("div", {
      className: "CharacterSheet-misterBadge"
    }, m("i", {
      className: "fas fa-clipboard-check"
    })), m("div", null, m("h4", {
      className: "CharacterSheet-misterTitle"
    }, data.mister_report.title || app.translator.trans('nagusi-character-sheet.forum.mister_title')), m("span", {
      className: "CharacterSheet-misterSubtitle"
    }, app.translator.trans('nagusi-character-sheet.forum.subtitle')))), m("div", {
      className: "CharacterSheet-misterBody"
    }, m("i", {
      className: "fas fa-quote-left CharacterSheet-quoteIcon"
    }), m("p", {
      className: "CharacterSheet-misterComment"
    }, data.mister_report.comment)))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/character-sheet/CharacterSheetPage', CharacterSheetPage);